export default "__VITE_ASSET__DXkkRjdc__"